import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { Stack, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
const hashCode = (str) => {
  var hash = 0,
    i,
    chr,
    len;
  if (str.length === 0) return hash;
  for (i = 0, len = str.length; i < len; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return Math.abs(hash);
};

export default function TutLecContentCard({
  name,
  contentKey,
  duration_mins,
  relevance,
  week,
  topicEmoji,
  topicName,
  live,
  lecture,
  thumbnail,
  studyStatus,
}) {
  const getRelevanceChip = (relevance) => {
    if (lecture) {
      switch (relevance) {
        case 'Mandatory':
          return { label: 'Mandatory', color: 'error' };
        case 'Catchup':
          return { label: 'Catchup', color: 'secondary' };
        case 'Recommended':
          return { label: 'Recommended', color: 'warning' };
        case 'Extension':
          return { label: 'Extension', color: 'info' };
        default:
          return { label: 'Unknown', color: 'default' };
      }
    } else {
      switch (relevance) {
        case 'COMPULSORY':
          return { label: 'Compulsory', color: 'error' };
        case 'REFINING':
          return { label: 'Refining', color: 'warning' };
        case 'EXTENDED':
          return { label: 'Extended', color: 'info' };
        default:
          return { label: 'Unknown', color: 'default' };
      }
    }
  };

  const isZoomLink = live && live.startsWith('https://') && live.toLowerCase().includes('zoom');
  const isLive = live === '🔴 NEW' || isZoomLink;
  const relevanceChip = getRelevanceChip(relevance);
  const fullWeek = 'Week ' + week;
  const topic = topicEmoji + ' ' + topicName;
  const hash = hashCode(contentKey) % 400;
  const cardLink = lecture
    ? `/NOW/content/lectures/${contentKey}`
    : `/NOW/content/tutorials/${contentKey}`;
  const isCompleted = studyStatus === 'completed';
  const studyStatusLabel = isCompleted ? 'Completed' : 'Not Completed';

  const cardContent = (
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          border: 'none',
          boxShadow: 'none',
          padding: '0px',
        }}
      >
        <CardContent sx={{ '&:last-child': { paddingBottom: '10px' }, padding: '10px 20px' }}>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row' }}
            alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}
            gap={2}
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                flex: 1,
                minWidth: 0,
                width: { xs: '100%', sm: '100%', md: 'auto' },
              }}
            >
              <Box sx={{ flexShrink: 0 }}>
                <img
                  src={thumbnail ? thumbnail : `https://picsum.photos/id/${hash}/200`}
                  alt={name}
                  style={{
                    width: 'auto',
                    height: '100px',
                    display: 'block',
                    borderRadius: '8px',
                  }}
                />
              </Box>

              <Stack
                direction="column"
                sx={{
                  px: 2,
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  width: { xs: '100%', sm: '100%', md: 200 },
                }}
              >
                <Tooltip title={name} placement="top" arrow disableInteractive>
                  <Typography
                    variant="h6"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: { xs: 'normal', sm: 'normal', md: 'nowrap' },
                      cursor: 'pointer',
                      display: '-webkit-box',
                      WebkitLineClamp: { xs: 2, sm: 2, md: 1 },
                      WebkitBoxOrient: 'vertical',
                      '&:hover': {
                        textDecoration: 'underline',
                        color: '#5b7edb',
                      },
                    }}
                  >
                    {name}
                  </Typography>
                </Tooltip>
                <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
                  {duration_mins} minutes
                </Typography>
              </Stack>
            </Stack>

            <Stack
              direction="row"
              gap={1}
              sx={{
                flexWrap: 'wrap',
                justifyContent: { xs: 'flex-start', sm: 'flex-start', md: 'flex-end' },
                width: { xs: '100%', sm: '100%', md: 'auto' },
                maxWidth: { md: '340px' },
                pl: { xs: 0, md: 2 },
                flexShrink: 1,
                minWidth: 0,
              }}
            >
              <Chip label={topic} size="small" />
              <Chip label={fullWeek} size="small" />
              <Chip color={relevanceChip.color} label={relevanceChip.label} size="small" />
              {lecture && (
                <Chip
                  color={isCompleted ? 'success' : 'default'}
                  label={studyStatusLabel}
                  size="small"
                />
              )}
              {isLive && <Chip color="secondary" label={'Live'} size="small" />}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
  );

  if (isZoomLink) {
    return (
      <a href={live} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        {cardContent}
      </a>
    );
  }

  return (
    <Link to={cardLink} style={{ textDecoration: 'none' }}>
      {cardContent}
    </Link>
  );
}
